import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import "leaflet/dist/leaflet.css";
import "./index.css";

const { hostname } = window.location;
const airgainHost = hostname.replace("nextivityinc.net", "airgain.net").replace("nextivity.cloud", "airgain.cloud");

if (airgainHost !== hostname) {
  // Legacy Nextivity host - redirect to the Airgain equivalent, keeping the path.
  window.location.replace(`https://${airgainHost}${window.location.pathname}${window.location.search}${window.location.hash}`);
} else {
  const app = document.getElementById("root");

  const root = ReactDOM.createRoot(app);

  window.onbeforeunload = function () {
    localStorage.removeItem("data");
    localStorage.removeItem("apiFailCount");
  };

  root.render(<App />);
}
